import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import ActionsUserCard from "../../components/ActionsUserCard";
import InfiniteScroll from 'react-infinite-scroll-component';

const MembershipRequests = () => {
    const { organization } = useParams();

    const [userList, setUserList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [acceptMembers, setAcceptMembers] = useState(false)

    useEffect(() => {
        const getRequests = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/${organization}/members/join`);
                if (response?.data) {
                    setUserList(response.data);
                } else {
                    setUserList([]);
                }
            } catch (error) {
                toast.error(
                    error?.response?.data?.message || "Failed to fetch membership requests."
                );
            } finally {
                setIsLoading(false);
            }
        };

        getRequests();
    }, [organization]);

    const refresh = () => {
        // Optionally refetch data here if you want pull-to-refresh to do something
    };

    const acceptAll = async () => {
        try {
            setAcceptMembers(true)
            const response = api.patch(`/${organization}/manage/members`)
            if (response) {
                setAcceptMembers(false)
                toast.success(response.data.message)
            }
        } catch (error) {
            setAcceptMembers(false)
            toast.error(error.response.data.message)
        }
    }

    return (
        <div>
            <h3 className="page-header-title">{organization}</h3><span>Membership Requests</span>
            <button className='action-btn' onClick={acceptAll}>{acceptMembers?<Loader/>:"Accept All"}</button>
            <div className="user-list">
                <InfiniteScroll
                    dataLength={userList.length}
                    pullDownToRefresh={true}
                    refreshFunction={refresh}
                    loader={<Loader />}
                // endMessage={<p style={{ textAlign: 'center' }}>No more requests</p>}
                >
                    {isLoading && <Loader />}
                    {!isLoading && userList.length === 0 && (
                        <p className="not-found-msg">No membership requests found</p>
                    )}
                    {!isLoading &&
                        userList.map((user) => (
                            <ActionsUserCard user={user} key={user._id} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default MembershipRequests;
